import { React, useState, classNames } from '@digsup/core-ui';
import { Button } from '@digsup/components-button';
import { Icon } from '@digsup/components-icon';
import { Text } from '@digsup/components-text';
import { PartnersModal } from './PartnersModal';

import { styles } from './PartnersBanner.scss';

const cx = classNames.bind(styles);

export const PartnersBanner = () => {
  const [modalActive, setModalActive] = useState(false);

  return (
    <>
      <div className={cx('l-homepage-partners-banner')} id="partner">
        <div className="l-homepage-partners-banner__card">
          <div className="l-homepage-partners-banner__inner">
            <Text
              size="sm"
              fontFamily="serif"
              fontWeight="semibold"
              marginBottom="large"
              className="u-margin-bottom-none@medium">
              Become a Partner
            </Text>
            <div className="u-shadow-level-10 u-text-align-center u-background-white u-border-radius-medium l-homepage-partners-banner__label">
              <div className="u-padding-top-small-stretched u-padding-bottom-small">
                <Icon
                  name="logo-monochrome"
                  className="l-homepage-partners-banner__label-icon"
                />
              </div>
              <Text
                size={{ xsmall: '4xs', large: '2xs' }}
                color="theme-white"
                className="u-padding-top-medium u-padding-bottom-medium u-background-digsup-blue">
                Partnerships
              </Text>
            </div>
            <Text className="u-margin-bottom-xlarge u-margin-bottom-large@medium">
              Apply to be a vetted 3rd party service provider in your area
            </Text>
            <ul className="l-homepage-partners-banner__list">
              <li>Brokers</li>
              <li>Appraisers</li>
              <li>Inspectors</li>
              <li>Attorneys</li>
              <li>Movers</li>
            </ul>
            <div className="l-homepage-partners-banner__cta-btn">
              <Button
                width="full"
                variant="flat"
                onClick={() => setModalActive(true)}>
                Apply Now
              </Button>
            </div>
          </div>
        </div>
      </div>
      <PartnersModal
        isOpen={modalActive}
        onClose={() => setModalActive(false)}
      />
    </>
  );
};
